export default __webpack_public_path__ + "img/b4449323c207a203d7d5c9072e8b7d4d.svg";